
import { IAccTextRenderEventArgs } from '@syncfusion/ej2-angular-charts';
export class SyncfusionChartSettingsHelper {
  static getBarChartSettings(labelText: string = 'percentage') {
    return {
      legendSettings: { visible: false, position: 'Top' },
      primaryXAxis: { valueType: 'Category', interval: 1, majorGridLines: { width: 0 } },
      primaryYAxis: { majorGridLines: { width: 0 }, majorTickLines: { width: 0 }, lineStyle: { width: 0 }, labelStyle: { color: 'transparent' } },
      marker: { dataLabel: { visible: true, position: 'Top', name: labelText, font: { fontWeight: '600', color: '#ffffff' } } },
      tooltip: { enable: true },
      chartArea: { border: { width: 0 } }
    };
  }

  static getCurrencyBarChartSettings(labelText: string = 'percentage') {
    return {
      ...this.getBarChartSettings(),
      marker: { dataLabel: { visible: false }},
      primaryYAxis: { labelFormat: 'c0', majorGridLines: { width: 0 } }
    };
  }

  static getPieChartSettings(labelText: string = 'percentage', currencyFormat: boolean = false) {
    return {
      legendSettings: { visible: true, position: 'Top', toggleVisibility: true },
      dataLabel: { visible: true, name: labelText, position: 'Outside' },
      startAngle:  0,
      endAngle: 360,
      tooltip: { enable: true, format: '${point.x}: ${point.percentage}%' },
      onTextRender: (args: IAccTextRenderEventArgs) => {
        if (currencyFormat) {
          const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          });

          args.text = formatter.format(args.point.y);
        }
      }
    };
  }

  static getLineChartSettings() {
    return {
      legendSettings: { visible: false, position: 'Top' },
      primaryXAxis: { valueType: 'Category' },
      primaryYAxis: { labelFormat: 'c0', rangePadding: 'None', minimum: 0, maximum: 100, interval: 20, lineStyle: { width: 0 }, majorTickLines: { width: 0 }, minorTickLines: { width: 0 } },
      chartArea: { border: { width: 0 } },
      marker: { visible: true, height: 10, width: 10 },
      tooltip: { enable: true }
    };
  }
}